import { Risk, Value } from "../units";
import { EyePressure } from "./eyePressure";

function riskFor({
  left,
  right,
}: {
  left: Value<"mmHg">;
  right: Value<"mmHg">;
}): Risk {
  const ranges = EyePressure.rangesFor();

  const risks: Risk[] = [];

  if (Math.abs(left.mmHg - right.mmHg) >= 4) {
    risks.push(Risk.Risk);
  }

  risks.push(ranges.findRisk(left), ranges.findRisk(right));

  return Math.max(...risks);
}

export const EyePressureCombined = {
  riskFor,
};
